import { isScriptGenerationEligible } from "@/features/opportunities/constants/script-generation";

import type { GenerateScriptsTarget } from "../components/workspace/generate-scripts/GenerateScriptsModal.js";

export interface CompetitorScriptGate {
  /** Targets holding only generatable angles; targets left empty are dropped. */
  eligibleTargets: GenerateScriptsTarget[];
  selectedCount: number;
  eligibleCount: number;
  ineligibleCount: number;
  /** Distinct datasets of the blocked competitor angles, in first-seen order. */
  ineligibleDatasets: string[];
}

/**
 * Competitor angles generate scripts from the Topics dataset only, as on the legacy
 * Opportunities page. Persona and custom-set angles are never gated.
 */
export function gateCompetitorScriptTargets(
  targets: readonly GenerateScriptsTarget[],
  datasetByOpportunityId: ReadonlyMap<string, string | undefined>,
): CompetitorScriptGate {
  const eligibleTargets: GenerateScriptsTarget[] = [];
  const ineligibleDatasets = new Set<string>();
  let selectedCount = 0;
  let ineligibleCount = 0;

  for (const target of targets) {
    selectedCount += target.angles.length;
    if (target.setType !== "COMPETITOR") {
      eligibleTargets.push(target);
      continue;
    }
    const angles = target.angles.filter((angle) => {
      const dataset = datasetByOpportunityId.get(angle.id) ?? "";
      if (isScriptGenerationEligible(dataset)) return true;
      ineligibleCount += 1;
      if (dataset) ineligibleDatasets.add(dataset);
      return false;
    });
    if (angles.length > 0) eligibleTargets.push({ ...target, angles });
  }

  return {
    eligibleTargets,
    selectedCount,
    eligibleCount: selectedCount - ineligibleCount,
    ineligibleCount,
    ineligibleDatasets: [...ineligibleDatasets],
  };
}
